.container {
    position: relative;
    min-width: 858px;
    padding: 15px 15px 30px;
}

.wrapper {
    width: 100%;
    border-collapse: collapse;
    vertical-align: top;
}

.wrapper td {
    vertical-align: top;
}

.centerColumn {
    padding: 0;
}

.centerColumn table {
    width: 100%;
}

.rightColumn {
    width: 200px;
    padding-left: 12px;
}
